/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-06-18
 */

/**
 * From the ownProps passed down to components from the router, extract the path parameters out.
 *
 * @param state Redux state, not applicable
 * @param params Router parameters
 * @returns {object} Router path parameters object
 */
export const getRouterParams = (state, ownProps) => ownProps && ownProps.match && ownProps.match.params;



// WEBPACK FOOTER //
// ./src/router.selectors.js